// extracted by mini-css-extract-plugin
export var spinner = "styles-module--spinner--77258";
export var status = "styles-module--status--5dbe2";
export var text = "styles-module--text--0cb7e";
export var toggle = "styles-module--toggle--92cf1";